import React, { useState } from 'react';
import { Sidebar } from '../ui/Sidebar';
import { Bell, Search, Grid, Menu } from 'lucide-react';
import { Input } from '../ui/Input';
import { Link } from 'react-router-dom';
interface CommandCenterLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}
export function CommandCenterLayout({
  children,
  title,
  subtitle
}: CommandCenterLayoutProps) {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-gray-50 flex font-sans text-gray-900" data-id="element-125">
      {/* Sidebar - Responsive */}
      <Sidebar isMobileOpen={isMobileSidebarOpen} onMobileClose={() => setIsMobileSidebarOpen(false)} data-id="element-126" />

      {/* Main Content Wrapper */}
      <div className="flex-1 flex flex-col min-w-0 transition-all duration-300" data-id="element-127">
        {/* Top Bar */}
        <header className="bg-white border-b border-gray-200 h-16 flex items-center justify-between px-4 md:px-6 sticky top-0 z-30 shadow-sm relative" data-id="element-128">
          {/* Top Accent Line */}
          <div className="absolute top-0 left-0 w-full h-0.5 bg-primary-600 z-40" data-id="element-129"></div>

          <div className="flex items-center gap-3 md:gap-4 min-w-0 flex-1 mr-4" data-id="element-130">
            {/* Mobile Menu Button */}
            <button className="lg:hidden p-2 -ml-2 text-gray-600 hover:bg-gray-100 rounded-md flex-shrink-0 transition-colors" onClick={() => setIsMobileSidebarOpen(true)} aria-label="Open menu" data-id="element-131">
              <Menu className="h-6 w-6" data-id="element-132" />
            </button>

            <div className="min-w-0 flex-1" data-id="element-133">
              <h1 className="text-lg font-semibold text-gray-900 tracking-tight truncate" data-id="element-134">
                {title || 'Command Center'}
              </h1>
              {subtitle && <p className="text-xs text-gray-500 hidden sm:block truncate font-medium" data-id="element-135">
                  {subtitle}
                </p>}
            </div>
          </div>

          <div className="flex items-center gap-2 md:gap-3 flex-shrink-0" data-id="element-136">
            <div className="hidden md:block w-64" data-id="element-137">
              <div className="relative group" data-id="element-138">
                <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400 group-focus-within:text-primary-500 transition-colors" data-id="element-139" />
                <Input placeholder="Cari data..." className="pl-9 bg-gray-50 border-gray-200 focus:bg-white focus:border-primary-500 focus:ring-primary-500/20 h-9 transition-all" data-id="element-140" />
              </div>
            </div>

            <Link to="/portal" className="p-2 text-gray-500 hover:bg-gray-100 hover:text-primary-600 rounded-full transition-colors" title="Kembali ke Portal" data-id="element-141">
              <Grid className="h-5 w-5" data-id="element-142" />
            </Link>

            <button className="p-2 text-gray-500 hover:bg-gray-100 hover:text-primary-600 rounded-full relative transition-colors" title="Notifikasi" data-id="element-143">
              <Bell className="h-5 w-5" data-id="element-144" />
              <span className="absolute top-1.5 right-1.5 h-2 w-2 bg-red-500 rounded-full border-2 border-white" data-id="element-145"></span>
            </button>

            <div className="h-9 w-9 bg-primary-600 rounded-full flex items-center justify-center text-white font-semibold text-sm shadow-sm ring-2 ring-white" data-id="element-146">
              AD
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-4 md:p-6 lg:p-8 overflow-auto w-full" data-id="element-147">
          <div className="max-w-[1600px] mx-auto w-full" data-id="element-148">{children}</div>
        </main>
      </div>
    </div>;
}